import apiClient from '@/services/axios'

class MediaService {
  async getPromoImage(promoId) {
    const url = `/admin/promo/${promoId}`
    return apiClient.get(url)
  }

  async getCustomLinks() {
    const url = '/admin/links?type=custom&results=1000'
    return apiClient.get(url)
  }

  async createLink(data) {
    const url = '/admin/links'
    return apiClient.post(url, data)
  }

  async deleteLink(linkId) {
    const url = `/admin/links/${linkId}`
    return apiClient.delete(url)
  }

  async getSports() {
    const url = '/admin/sports?results=1000'
    return apiClient.get(url)
  }

  async uploadImage(file) {
    const formData = new FormData()
    formData.append('file', file.originFileObj)
    const url = '/admin/medias/images'
    return apiClient.post(url, formData)
  }

  async startExport(data) {
    const url = '/admin/medias/export'
    return apiClient.post(url, data)
  }

  async checkExportStatus(exportType) {
    const url = `/admin/medias/export/status?type=${exportType}`
    return apiClient.get(url)
  }

  // BANNERS

  async getBanners(searchParams) {
    const url = `/admin/medias/banners?${searchParams}`
    return apiClient.get(url)
  }

  async getBanner(id) {
    const url = `/admin/medias/banners/${id}`
    return apiClient.get(url)
  }

  async createBanner(data) {
    const url = '/admin/medias/banners'
    return apiClient.post(url, data)
  }

  async updateBanner(id, data) {
    const url = `/admin/medias/banners/${id}`
    return apiClient.patch(url, data)
  }

  async sortBanners(appId, data) {
    const url = `/admin/medias/banners/sort/${appId}`
    return apiClient.patch(url, data)
  }

  async changeBannerStatus(id, bannerStatus) {
    const url = `/admin/banners/${id}/status`
    return apiClient.patch(url, bannerStatus)
  }

  async deleteBanner(id) {
    const url = `/admin/medias/banners/${id}`
    return apiClient.delete(url)
  }

  // STORIES

  async getStories(searchParams) {
    const url = `/admin/medias/stories?${searchParams}`
    return apiClient.get(url)
  }

  async getStory(id) {
    const url = `/admin/medias/stories/${id}`
    return apiClient.get(url)
  }

  async createStory(data) {
    const url = '/admin/medias/stories'
    return apiClient.post(url, data)
  }

  async updateStory(id, data) {
    const url = `/admin/medias/stories/${id}`
    return apiClient.patch(url, data)
  }

  async sortStories(appId, data) {
    const url = `/admin/medias/stories/sort/${appId}`
    return apiClient.patch(url, data)
  }

  async changeStoryStatus(id, storyStatus) {
    const url = `/admin/stories/${id}/status`
    return apiClient.patch(url, storyStatus)
  }

  async deleteStory(id) {
    const url = `/admin/medias/stories/${id}`
    return apiClient.delete(url)
  }

  // SPLASHSCREENS

  async getSplashscreens(searchParams) {
    const url = `/admin/splashscreens?${searchParams}`
    return apiClient.get(url)
  }

  async createSplashscreen(data) {
    const url = '/admin/splashscreens'
    return apiClient.post(url, data)
  }

  async updateSplashscreen(splashscreenId, data) {
    const url = `/admin/splashscreens/${splashscreenId}`
    return apiClient.patch(url, data)
  }

  async changeSplashscreenStatus(splashscreenId, splashscreenStatus) {
    const url = `/admin/stories/${splashscreenId}/status`
    return apiClient.patch(url, splashscreenStatus)
  }

  async updateSplashscreenCover(file, splashscreenId) {
    const formData = new FormData()
    formData.append('cover', file.originFileObj)

    const url = `/admin/splashscreens/${splashscreenId}/cover`
    return apiClient.post(url, formData)
  }

  async deleteSplashscreen(splashscreenId) {
    const url = `/admin/splashscreens/${splashscreenId}`
    return apiClient.delete(url)
  }

  // INFORMERS

  async getInformers(searchParams) {
    const url = `/admin/medias/informers?${searchParams}`
    return apiClient.get(url)
  }

  async getInformer(id) {
    const url = `/admin/medias/informers/${id}`
    return apiClient.get(url)
  }

  async createInformer(data) {
    const url = '/admin/medias/informers'
    return apiClient.post(url, data)
  }

  async updateInformer(id, data) {
    const url = `/admin/medias/informers/${id}`
    return apiClient.patch(url, data)
  }

  async sortInformers(appId, data) {
    const url = `/admin/medias/informers/sort/${appId}`
    return apiClient.patch(url, data)
  }

  async changeInformerStatus(id, informerStatus) {
    const url = `/admin/informers/${id}/status`
    return apiClient.patch(url, informerStatus)
  }

  async deleteInformer(id) {
    const url = `/admin/medias/informers/${id}`
    return apiClient.delete(url)
  }

  // POPUPS

  async getPopups(searchParams) {
    const url = `/admin/medias/popup-banners?${searchParams}`
    return apiClient.get(url)
  }

  async getPopup(id) {
    const url = `/admin/medias/popup-banners/${id}`
    return apiClient.get(url)
  }

  async createPopup(data) {
    const url = '/admin/medias/popup-banners'
    return apiClient.post(url, data)
  }

  async updatePopup(id, data) {
    const url = `/admin/medias/popup-banners/${id}`
    return apiClient.patch(url, data)
  }

  async sortPopups(appId, data) {
    const url = `/admin/medias/popup-banners/sort/${appId}`
    return apiClient.patch(url, data)
  }

  async changePopupStatus(id, status) {
    const url = `/admin/popup-banners/${id}/status`
    return apiClient.patch(url, status)
  }

  async deletePopup(id) {
    const url = `/admin/medias/popup-banners/${id}`
    return apiClient.delete(url)
  }
}
export default new MediaService()
